import IpPoolsList from './ListPage';
import CreatePage from './CreatePage';
import EditPage from './EditPage';
import EditIpPage from './EditIpPage';

export default {
  ListPage: IpPoolsList,
  CreatePage,
  EditPage,
  EditIpPage
};
